import React, {useState} from "react";
import {Button, Modal} from "antd";

const JsonReader = ({
                        accept = '.json, text/csv', cssClass = 'csv-reader-input',
                        cssInputClass = 'csv-input',
                        cssLabelClass = 'csv-label',
                        fileEncoding = 'UTF-8',
                        inputId = 'react-csv-reader-input',
                        inputName = 'react-csv-reader-input',
                        inputStyle = {},
                        label,
                        onError = () => {
                        },
                        onFileLoaded,
                        disabled = false,
                        strict = false,
                    }) => {
    const handleChangeFile = (e) => {
        let reader = new FileReader()
        const files = e.target.files


        if (files.length > 0) {
            const fileInfo = {
                name: files[0].name,
                size: files[0].size,
                type: files[0].type,
            }

            if (strict && accept.indexOf(fileInfo.type) <= 0) {
                onError(new Error(`[strict mode] Accept type not respected: got '${fileInfo.type}' but not in '${accept}'`))
                return
            }

            reader.onload = (_event) => {
                const s = _event.target.result
                onFileLoaded(JSON.parse(s))
            }

            reader.readAsText(files[0], fileEncoding)
        }
    }

    return (
        <div className={cssClass}>
            {label && (
                <label className={cssLabelClass} htmlFor={inputId}>
                    {label}
                </label>
            )}
            <input
                className={cssInputClass}
                type="file"
                id={inputId}
                name={inputName}
                style={inputStyle}
                accept={accept}
                onChange={handleChangeFile}
                disabled={disabled}
            />
        </div>
    )
}
export const ModalJsonFileInputButton = ({onImport}) => {
    const [open, setOpen] = useState(false)
    const [data, setData] = useState(false)
    const doHideCancel = () => setOpen(false)
    const doHideOk = () => {
        setOpen(false)
        onImport(data)
    }
    const doShow = () => setOpen(true)

    return <>
        <Button style={{float: 'right', margins: 16}} onClick={doShow}>Импорт</Button>
        <Modal visible={open} onOk={doHideOk} onCancel={doHideCancel}>
            <JsonReader label={"Выберите файл для импорта"} onFileLoaded={(_data) => setData(_data)}/>
        </Modal>
    </>
}